import altitude from "../../../../public/projects/M3M/images/projects/altitude.webp";
import antalya from "../../../../public/projects/M3M/images/projects/antalya.webp";
import capital from "../../../../public/projects/M3M/images/projects/capital.webp";
import crown from "../../../../public/projects/M3M/images/projects/crown.webp";
import GolfHills from "../../../../public/projects/M3M/images/projects/GolfHills.webp";
import opus from "../../../../public/projects/M3M/images/projects/opus.webp";
import Mansion from "../../../../public/projects/M3M/images/projects/Mansion.webp";
import myden from "../../../../public/projects/M3M/images/projects/myden.webp";
import logo from "../../../../public/projects/M3M/images/logo/logo.png";

// Altitude
import overviewImage_altitude from "../../../../public/projects/M3M/images/altitude/Overview/1.webp";
import bannerDesktopImage_altitude from "../../../../public/projects/M3M/images/altitude/Banner/1.webp";
import bannerMobileImage_altitude from "../../../../public/projects/M3M/images/altitude/Banner/2.webp";
import siteVisitBannerImage_altitude from "../../../../public/projects/M3M/images/altitude/SiteVisitBanner/1.webp";
import Location_altitude from "../../../../public/projects/M3M/images/altitude/Location/L1.webp";
import Hightlights_altitude from "../../../../public/projects/M3M/images/altitude/Highlights/1.webp";
import image1BHK_altitude from "../../../../public/projects/M3M/images/altitude/floorplan/1.webp";
import image2BHK_altitude from "../../../../public/projects/M3M/images/altitude/floorplan/2.webp";
import image3BHK_altitude from "../../../../public/projects/M3M/images/altitude/floorplan/3.webp";
import location_altitude from "../../../../public/projects/M3M/images/altitude/Overview/l.png";
import cal_altitude_altitude from "../../../../public/projects/M3M/images/altitude/Overview/c.png";
import  newlaunch_altitude_antalya_hills_altitude from "../../../../public/projects/M3M/images/altitude/Overview/n.png";
import g1_altitude from "../../../../public/projects/M3M/images/altitude/Gallery/1.webp";
import g2_altitude from "../../../../public/projects/M3M/images/altitude/Gallery/2.webp";
import g3_altitude from "../../../../public/projects/M3M/images/altitude/Gallery/3.webp";
import g4_altitude from "../../../../public/projects/M3M/images/altitude/Gallery/4.webp";
import g5_altitude from "../../../../public/projects/M3M/images/altitude/Gallery/5.webp";

//Mansion
import overviewImage_mansion from "../../../../public/projects/M3M/images/mansion/Overview/1.webp";
import bannerDesktopImage_mansion from "../../../../public/projects/M3M/images/mansion/Banner/1.webp";
import bannerMobileImage_mansion from "../../../../public/projects/M3M/images/mansion/Banner/2.webp";
import siteVisitBannerImage_mansion from "../../../../public/projects/M3M/images/mansion/SiteVisitBanner/1.webp";
import Location_mansion from "../../../../public/projects/M3M/images/mansion/Location/L1.webp";
import Hightlights_mansion from "../../../../public/projects/M3M/images/mansion/Highlights/1.webp";
import image1BHK_mansion from "../../../../public/projects/M3M/images/mansion/floorplan/1.webp";
import image2BHK_mansion from "../../../../public/projects/M3M/images/mansion/floorplan/2.webp";
import image3BHK_mansion from "../../../../public/projects/M3M/images/mansion/floorplan/3.webp";
import location_mansion from "../../../../public/projects/M3M/images/mansion/Overview/l.png";
import cal_altitude_mansion from "../../../../public/projects/M3M/images/mansion/Overview/c.png";
import  newlaunch_altitude_antalya_hills_mansion from "../../../../public/projects/M3M/images/mansion/Overview/n.png";
import g1_mansion from "../../../../public/projects/M3M/images/mansion/Gallery/1.webp";
import g2_mansion from "../../../../public/projects/M3M/images/mansion/Gallery/2.webp";
import g3_mansion from "../../../../public/projects/M3M/images/mansion/Gallery/3.webp";
import g4_mansion from "../../../../public/projects/M3M/images/mansion/Gallery/4.webp";
import g5_mansion from "../../../../public/projects/M3M/images/mansion/Gallery/5.webp";

//Golf Hills
import overviewImage_golfhills from "../../../../public/projects/M3M/images/golf_hills/Overview/1.webp";
import bannerDesktopImage_golfhills from "../../../../public/projects/M3M/images/golf_hills/Banner/1.webp";
import bannerMobileImage_golfhills from "../../../../public/projects/M3M/images/golf_hills/Banner/2.webp";
import siteVisitBannerImage_golfhills from "../../../../public/projects/M3M/images/golf_hills/SiteVisitBanner/1.webp";
import Location_golfhills from "../../../../public/projects/M3M/images/golf_hills/Location/L1.webp";
import Hightlights_golfhills from "../../../../public/projects/M3M/images/golf_hills/Highlights/1.webp";
import image1BHK_golfhills from "../../../../public/projects/M3M/images/golf_hills/floorplan/1.webp";
import image2BHK_golfhills from "../../../../public/projects/M3M/images/golf_hills/floorplan/2.webp";
import image3BHK_golfhills from "../../../../public/projects/M3M/images/golf_hills/floorplan/3.webp";
import location_golfhills from "../../../../public/projects/M3M/images/golf_hills/Overview/l.png";
import cal_altitude from "../../../../public/projects/M3M/images/golf_hills/Overview/c.png";
import  newlaunch_altitude_antalya_hills_golfhills from "../../../../public/projects/M3M/images/golf_hills/Overview/n.png";
import g1_golfhills from "../../../../public/projects/M3M/images/golf_hills/Gallery/1.webp";
import g2_golfhills from "../../../../public/projects/M3M/images/golf_hills/Gallery/2.webp";
import g3_golfhills from "../../../../public/projects/M3M/images/golf_hills/Gallery/3.webp";
import g4_golfhills from "../../../../public/projects/M3M/images/golf_hills/Gallery/4.webp";
import g5_golfhills from "../../../../public/projects/M3M/images/golf_hills/Gallery/5.webp";

//Crown
import overviewImage_crown from "../../../../public/projects/M3M/images/crown/Overview/1.webp";
import bannerDesktopImage_crown from "../../../../public/projects/M3M/images/crown/Banner/1.webp";
import bannerMobileImage_crown from "../../../../public/projects/M3M/images/crown/Banner/2.webp";
import siteVisitBannerImage_crown from "../../../../public/projects/M3M/images/crown/SiteVisitBanner/1.webp";
import Location_crown from "../../../../public/projects/M3M/images/crown/Location/L1.webp";
import Hightlights_crown from "../../../../public/projects/M3M/images/crown/Highlights/1.webp";
import image1BHK_crown from "../../../../public/projects/M3M/images/crown/floorplan/1.webp";
import image2BHK_crown from "../../../../public/projects/M3M/images/crown/floorplan/2.webp";
import image3BHK_crown from "../../../../public/projects/M3M/images/crown/floorplan/3.webp";
import location_crown from "../../../../public/projects/M3M/images/crown/Overview/l.png";
import cal_altitude_crown from "../../../../public/projects/M3M/images/crown/Overview/c.png";
import  newlaunch_altitude_antalya_hills_crown from "../../../../public/projects/M3M/images/crown/Overview/n.png";
import g1_crown from "../../../../public/projects/M3M/images/crown/Gallery/1.webp";
import g2_crown from "../../../../public/projects/M3M/images/crown/Gallery/2.webp";
import g3_crown from "../../../../public/projects/M3M/images/crown/Gallery/3.webp";
import g4_crown from "../../../../public/projects/M3M/images/crown/Gallery/4.webp";
import g5_crown from "../../../../public/projects/M3M/images/crown/Gallery/5.webp";

//Antalya Hills
import overviewImage_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Overview/1.webp";
import bannerDesktopImage_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Banner/1.webp";
import bannerMobileImage_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Banner/2.webp";
import siteVisitBannerImage_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/SiteVisitBanner/1.webp";
import Location_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Location/L1.webp";
import Hightlights_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Highlights/1.webp";
import image1BHK_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/floorplan/1.webp";
import image2BHK_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/floorplan/2.webp";
import image3BHK_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/floorplan/3.webp";
import location_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Overview/l.png";
import cal_altitude_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Overview/c.png";
import  newlaunch_altitude_antalya_hills_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Overview/n.png";
import g1_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Gallery/1.webp";
import g2_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Gallery/2.webp";
import g3_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Gallery/3.webp";
import g4_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Gallery/4.webp";
import g5_antalya_hills from "../../../../public/projects/M3M/images/antalya_hills/Gallery/5.webp";

export const Headers = {
  logo: logo,
  data: {
    experience: `2010`,
    projects: `118`,
    ongoingprojects: `18`,
  },
  about: `One of the top real estate developers, M3M is renowned for building outstanding
Indian residential and commercial developments. renowned for its inventiveness, excellence, and promptness 
M3M provides modern offices and opulent living. Its innovations incorporate top-notch
superior facilities, architecture, and strategic
sites, changing urban lifestyles and client satisfaction.`,
};

export const developersM3M = {
  name: `M3M Properties in Gurugram`,
  properties: [
    {
      name: "M3M - Altitude",
      developer: "M3M",
      image: altitude,
      price: "On Request",
      state: "Gurugram",
      projectlocation: "Golf Course Extention Road",
      developer: "M3M",
      location: "Sector 65",
      bed: "2 - 4 BHK",
      size: "....",
      url: `/m3m-altitude-sector-65-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `/gviwzD0n+l5FWFX3TrhJukSQnU05OqskRJUH/LHnfUrxoS6B+yCHcS7V+kdp4wW`,
        api_userSecretKey: `k8X2fH5YCygArXlL7WJBCFLiJA2haVP3iVngXbPBWFF14gNKEl5mf4M=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "M3M - Mansion",
      image: Mansion,
      price: "On Request",
      developer: "M3M",
      state: "Gurugram",
      projectlocation: "Dwarka Expressway",
      location: "Sector 113 ",
      bed: "3 - 5 BHK",
      size: "....",
      url: `/m3m-mansions-sector-113-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `kwm3G7ZL2zeBbAboxBnd4+3dqXz7Dv7PUK3/MDsjcrRkzebQjvFLYtvYaII7jar4`,
        api_userSecretKey: `n0rKmQpd7eEMCpxfID2nvzJg0LtjyOAz5mQ+DrnV/rJj30Tgm8O3g7c=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "M3M - Golf Hills",
      image: GolfHills,
      price: "On Request",
      developer: "M3M",
      state: "Gurugram",
      projectlocation: "Golf Course Road",
      location: "Sector 79 ",
      bed: "2.5 & 3.5 BHK",
      size: "....",
      url: `/m3m-golf-hills-sector-79-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `CwNJvkdl4SXQbioW3A+AfW3JSi+WTXWcnSZUtGOYntBpNSQ5iLSSDc5KjLZZfIQO`,
        api_userSecretKey: `2vnRfGW2+Xgne+ZAvWZ7S1FVr/Ve8t1N8K/Z5uhEIweIfZG8dRZHfeE=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "M3M - Crown",
      image: crown,
      price: "On Request",
      developer: "M3M",
      state: "Gurugram",
      projectlocation: "Dwarka Expressway",
      location: "Sector 111 ",
      bed: "3 - 4 BHK",
      developer: "M3M",
      size: "....",
      url: `/m3m-crown-sector-111-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `jJ2KcO92YUAQ4D1xLtAEDFKZr3SszswFbzyEa9Nyr5xOCanHoWyz8VgN0mTMoov0`,
        api_userSecretKey: `dEu2Lr/pQM0RhWIbECOgFfZo0DVGE1+GeJtyzDijuv3m02GEArd1+x4=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "M3M - Antalya",
      image: antalya,
      developer: "M3M",
      price: "On Request",
      state: "Gurugram",
      projectlocation: "Dwarka Expressway",
      location: "Sector 79 ",
      bed: "2.5 - 3.5 BHK",
      size: "....",
      url: `/m3m-antalya-hills-sector-79-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `UxnDkFbHxyiobw5sq2VRgJyU1ACW2akfrVYD6QcjetYTsWcXhd7RJjGH/DZWfKhc`,
        api_userSecretKey: `bM52Y3a/rKWN54rCYBf3Fx6qk8+YTcRTKfJo3nXaJRK5vsKJ7QpZ37c=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const projectsm3m = {
  m3maltitude: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_altitude,
      bannerMobileImage: bannerMobileImage_altitude,
      textOverlay: "",
      data: {
        title: "M3M Altitude",
        subtitle: "Sector 65, Gurugram",
        starting_price: "₹7.47 Cr*",
        rerano: "GGM/821/553/2024/48",
        payment_plan: "",
        status: "New Launch",
      },
    },
    overview: {
      heading: "M3M Altitude Sector 65 Gurugram",
      description: [
        `M3M Altitude Sector 65 in Gurugram is designed to cater to a wide range of lifestyles, offering an array of amenities that enhance everyday 
       living. Whether you're a fitness enthusiast, a nature admirer, or someone who enjoys life’s little luxuries, there’s something here for everyone. 
       The high-tech gymnasium provides the perfect space for workout sessions, while the lush green gardens offer a serene escape from the fast-paced city life.  
For those who love socializing and entertainment, the clubhouse serves as a vibrant hub, bringing neighbors and friends together. 
Equipped with modern facilities, it’s an ideal space for community gatherings, celebrations, or simply unwinding with like-minded individuals.  
Security is a top priority at M3M Altitude, with 24-hour surveillance and manned entry points ensuring a safe and secure environment.
 With advanced security systems in place, residents can enjoy complete peace of mind, knowing their loved ones and belongings are well-protected.  
Beyond the gated community, Gurugram presents a dynamic urban landscape filled with opportunities for leisure and entertainment. 
From world-class restaurants and shopping destinations to historic landmarks and green retreats, the city offers a diverse mix of 
experiences waiting to be explored.`,
      ],
      image: overviewImage_altitude,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_altitude,
          title: "₹7.47 Cr*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_altitude_altitude,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass:  newlaunch_altitude_antalya_hills_altitude,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_altitude,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4.5 BHK + S",
          area: "3755 sq. ft.",
          price: "₹7.47 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "4.5 BHK + S",
          area: "4245 sq. ft.",
          price: "₹ 8.44 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "4.5 BHK + S",
          area: "4270  sq. ft.",
          price: "₹8.49 Crs*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "4.5 BHK + S",
        area: "3755 sq. ft.",
        price: "₹7.47 Crs*",
        image: image1BHK_altitude,
      },
      {
        type: "4.5 BHK + S",
        area: "4245 sq. ft.",
        price: "₹ 8.44 Crs*",
        image: image2BHK_altitude,
      },
      {
        type: "4.5 BHK + S",
        area: "4270  sq. ft.",
        price: "₹8.49 Crs*",
        image: image3BHK_altitude,
      },
    ],

    highlights: {
      images: Hightlights_altitude,
      tagline: "Highlights",
      features: [
        "High-rise building adorned with beautiful external lighting.",
        "Modern contemporary architecture crafted by UHA, London.",
        "Luxury and leisure blend seamlessly, with lounges offering regal comfort and pools glistening with opulence.",
        "Each apartment features a balcony in the living room or bedroom.",
        "Enhanced security with an Intelligent Home Access Control system.",
      ],
    },

    location: {
      image: Location_altitude,
      data:[
        {
          airport:{
            distance_time:"25.8 Kms",
            name:"Indira Gandhi INT Airport"
          },
          school:{
            distance_time:"450 Meter",
            name:"Delhi Public School"
          },
          railwayormetro:{
            distance_time:"13.4 Kms",
            name:"Gurugram Railway station"
          },
          hospital:{
            distance_time:"3.6 Kms",
            name:"Park Hospital"
          },
          mall:{
            distance_time:"1.5 Kms",
            name:"WorldMark Gurugram"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_altitude },
        { image: g2_altitude },
        { image: g3_altitude },
        { image: g4_altitude },
        { image: g5_altitude },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in M3M Altitude, kindly share more details.",
    },

    faq: [
     
      {
        question: "Where is M3M Altitude situated?",
        answer: `The project is strategically located in Sector 65, Gurugram, along the Golf Course Extension Road. This prime location ensures excellent connectivity to major business hubs, shopping centers, educational institutions, and healthcare facilities.`,
      },
      {
        question: "What are the available configurations and sizes of the apartments?",
        answer: `M3M Altitude offers 4.5 BHK apartments with sizes ranging from 3,755 to 4,270 square feet.`,
      },
      {
        question: "What is the starting price of an apartment in M3M Altitude?",
        answer: `The starting price for an apartment is approximately ₹8.97 crore.`,
      },
      {
        question: "Who is the architect behind M3M Altitude?",
        answer: `The project features modern contemporary architecture designed by UHA, London.`,
      },
      {
        question: "What are some of the key amenities offered at M3M Altitude?",
        answer: `Residents can enjoy a range of amenities, including a sky clubhouse at 130 meters height, infinity edge pool, sky lounge, rooftop observatory deck, fine dining options, spa, wellness center, gymnasium, jacuzzi, steam and sauna facilities, professional maintenance services, and 5-tier security.`,
      },
      {
        question: "What makes M3M Altitude a standout choice for homebuyers?",
        answer: `M3M Altitude in Sector 65, Gurugram, stands out as a premier choice for homebuyers seeking a blend of luxury, convenience, and modern living.`,
      },
      {
        question: "Is there a clubhouse in the project?",
        answer: `Yes, M3M Altitude boasts a lavish clubhouse spanning 125,000 square feet, equipped with world-class amenities for leisure and recreation.`,
      },
      {
        question: "What security features are implemented in M3M Altitude?",
        answer: `The project ensures enhanced security with a 5-tier security system and an intelligent home access control system.`,
      },
      {
        question: "Are there any special features in the apartments?",
        answer: `Each apartment is designed with balconies in the living room or bedroom, allowing abundant natural light.`,
      },
      {
        question: "What is the total area and structure of the project?",
        answer: `M3M Altitude spans 4 acres and comprises three high-rise towers, each with a height of Ground + 43 floors, totaling 480 unit.`,
      },
    ],
    similar: {
      properties: [
       
        {
          name: "M3M - Mansion",
          image: Mansion,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 113 ",
          bed: "3 - 5 BHK",
          size: "....",
          url: `/m3m-mansions-sector-113-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `kwm3G7ZL2zeBbAboxBnd4+3dqXz7Dv7PUK3/MDsjcrRkzebQjvFLYtvYaII7jar4`,
            api_userSecretKey: `n0rKmQpd7eEMCpxfID2nvzJg0LtjyOAz5mQ+DrnV/rJj30Tgm8O3g7c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Golf Hills",
          image: GolfHills,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          location: "Sector 79 ",
          bed: "2.5 & 3.5 BHK",
          size: "....",
          url: `/m3m-golf-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `CwNJvkdl4SXQbioW3A+AfW3JSi+WTXWcnSZUtGOYntBpNSQ5iLSSDc5KjLZZfIQO`,
            api_userSecretKey: `2vnRfGW2+Xgne+ZAvWZ7S1FVr/Ve8t1N8K/Z5uhEIweIfZG8dRZHfeE=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Crown",
          image: crown,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 111 ",
          bed: "3 - 4 BHK",
          developer: "M3M",
          size: "....",
          url: `/m3m-crown-sector-111-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `jJ2KcO92YUAQ4D1xLtAEDFKZr3SszswFbzyEa9Nyr5xOCanHoWyz8VgN0mTMoov0`,
            api_userSecretKey: `dEu2Lr/pQM0RhWIbECOgFfZo0DVGE1+GeJtyzDijuv3m02GEArd1+x4=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Antalya",
          image: antalya,
          developer: "M3M",
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 79 ",
          bed: "2.5 - 3.5 BHK",
          size: "....",
          url: `/m3m-antalya-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `UxnDkFbHxyiobw5sq2VRgJyU1ACW2akfrVYD6QcjetYTsWcXhd7RJjGH/DZWfKhc`,
            api_userSecretKey: `bM52Y3a/rKWN54rCYBf3Fx6qk8+YTcRTKfJo3nXaJRK5vsKJ7QpZ37c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  m3mmansion: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_mansion,
      bannerMobileImage: bannerMobileImage_mansion,
      textOverlay: "",
      data: {
        title: "M3M Mansion",
        subtitle: "Sector 113, Gurugram",
        starting_price: "₹4.57 Crs*",
        rerano: "GGM/802/534/2024/29",
        payment_plan: "CLP",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Discover Luxury Living at M3M Mansion",
      description: [
        `Welcome to M3M Mansion in Sector 113, Gurugram, where luxury and comfort converge. These exquisite residences offer spacious living spaces with elegant designs and premium finishes. Enjoy a lifestyle enriched by world-class amenities including a clubhouse, swimming pool, and landscaped gardens.

With excellent connectivity and proximity to essential facilities, M3M Mansion promises a sophisticated urban living experience.

Discover the epitome of luxury at M3M Mansion, where every detail is crafted for your utmost satisfaction and convenience.`,
      ],
      image: overviewImage_mansion,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_mansion,
          title: "₹4.57 Crs*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_altitude_mansion,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass:  newlaunch_altitude_antalya_hills_mansion,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_mansion,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3.5 BHK + S",
          area: "2080 sq. ft.",
          price: "₹4.57 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "3.5 BHK + S",
          area: "2570 sq. ft.",
          price: "₹5.65 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "4.5 BHK + S",
          area: "3000  sq. ft.",
          price: "₹6.6 Crs*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3.5 BHK + S",
        area: "2080 sq. ft.",
        price: "₹4.57 Crs*",
        image: image1BHK_mansion,
      },
      {
        type: "3.5 BHK + S",
        area: "2570 sq. ft.",
        price: "₹5.65 Crs*",
        image: image2BHK_mansion,
      },
      {
        type: "4.5 BHK + S",
        area: "3000  sq. ft.",
        price: "₹6.6 Crs*",
        image: image3BHK_mansion,
      },
    ],

    highlights: {
      images: Hightlights_mansion,
      tagline: "Highlights",
      features: [
        "One Stop Destination For Live- Work And Play.",
        "Unmatched views of Delhi Reserve Greens & Central Greens.",
        "Best Practices Adopted From World’s 12 Most Recognized Urban Developments.",
        "Located On The Dwarka Expressway, Well Connected To The Airport.",
        "Strategical_altitudely placed at the Border of Delhi and Gurugram.",
      ],
    },

    location: {
      image: Location_mansion,
      data:[
        {
          airport:{
            distance_time:"2 kms",
            name:"IGI Airport"
          },
          school:{
            distance_time:"0.7 Kms",
            name:"Cs Public School"
          },
          railwayormetro:{
            distance_time:"3 Kms",
            name:"Sarai Kale Khan Station"
          },
          hospital:{
            distance_time:"1.9 Kms",
            name:"Chetanya Hospital"
          },
          mall:{
            distance_time:"11.6 Kms",
            name:"Sahara Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_mansion },
        { image: g2_mansion },
        { image: g3_mansion },
        { image: g4_mansion },
        { image: g5_mansion },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in M3M Mansion, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is M3M Mansion located?",
        answer: `M3M Mansion is situated in Sector 113, Gurugram, along the Dwarka Expressway, providing seamless connectivity to Delhi, IGI Airport, and major business hubs.`,
      },
      {
        question: "What types of residences are available in M3M Mansion?",
        answer: `The project offers ultra-luxurious 3.5 BHK and 4.5 BHK apartments, high-end interiors, and smart home features.`,
      },
      {
        question: "What are the key amenities in M3M Mansion?",
        answer: `M3M Mansion provides top-notch amenities, including a grand clubhouse, infinity swimming pool, landscaped gardens, spa, gym, sports courts, kids’ play area, and 24/7 security.`,
      },
      {
        question: "Is M3M Mansion RERA-approved?",
        answer: `Yes, M3M Mansion is RERA-approved, ensuring transparency and compliance with real estate regulations. `,
      },
      {
        question: "What is the price range of apartments in M3M Mansion?",
        answer: `The price of apartments in M3M Mansion varies based on the unit size and configuration. 3.5 BHK (2080 sq. ft.) = ₹4.57 Crs* and 4.5 BHK (3000 sq. ft.) = ₹6.6 Crs*.`,
      },
      {
        question: "What makes M3M Mansion a premium residential choice?",
        answer: `M3M Mansion stands out for its strategic location, world-class architecture, luxury interiors, and top-tier amenities, making it one of the most sought-after residences in Gurugram.`,
      },
      {
        question: "How well is M3M Mansion connected to key locations?",
        answer: `The project enjoys excellent connectivity via Dwarka Expressway, NH-8, and metro stations, offering easy access to IGI Airport, Cyber City, Ambience Mall, and Delhi’s prime areas.`,
      },
      {
        question: "What makes M3M Mansion a standout choice for homebuyers?",
        answer: `M3M Mansion in Sector 113, Gurugram, is an ultra-luxurious residential project that stands out as a prime choice for homebuyers due to its premium offerings, strategic location, and world-class amenities.`,
      },
      {
        question: "Who is the developer of M3M Mansion?",
        answer: `M3M Mansion is developed by M3M India, a renowned real estate developer known for delivering high-end residential and commercial projects in Gurugram.`,
      },
      {
        question: "What is the expected possession date of M3M Mansion?",
        answer: `The expected possession date of M3M Mansion is March 2030.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "M3M - Altitude",
          developer: "M3M",
          image: altitude,
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Golf Course Extention Road",
          developer: "M3M",
          location: "Sector 65",
          bed: "2 - 4 BHK",
          size: "....",
          url: `/m3m-altitude-sector-65-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `/gviwzD0n+l5FWFX3TrhJukSQnU05OqskRJUH/LHnfUrxoS6B+yCHcS7V+kdp4wW`,
            api_userSecretKey: `k8X2fH5YCygArXlL7WJBCFLiJA2haVP3iVngXbPBWFF14gNKEl5mf4M=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
    
        {
          name: "M3M - Golf Hills",
          image: GolfHills,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          location: "Sector 79 ",
          bed: "2.5 & 3.5 BHK",
          size: "....",
          url: `/m3m-golf-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `CwNJvkdl4SXQbioW3A+AfW3JSi+WTXWcnSZUtGOYntBpNSQ5iLSSDc5KjLZZfIQO`,
            api_userSecretKey: `2vnRfGW2+Xgne+ZAvWZ7S1FVr/Ve8t1N8K/Z5uhEIweIfZG8dRZHfeE=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Crown",
          image: crown,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 111 ",
          bed: "3 - 4 BHK",
          developer: "M3M",
          size: "....",
          url: `/m3m-crown-sector-111-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `jJ2KcO92YUAQ4D1xLtAEDFKZr3SszswFbzyEa9Nyr5xOCanHoWyz8VgN0mTMoov0`,
            api_userSecretKey: `dEu2Lr/pQM0RhWIbECOgFfZo0DVGE1+GeJtyzDijuv3m02GEArd1+x4=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Antalya",
          image: antalya,
          developer: "M3M",
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 79 ",
          bed: "2.5 - 3.5 BHK",
          size: "....",
          url: `/m3m-antalya-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `UxnDkFbHxyiobw5sq2VRgJyU1ACW2akfrVYD6QcjetYTsWcXhd7RJjGH/DZWfKhc`,
            api_userSecretKey: `bM52Y3a/rKWN54rCYBf3Fx6qk8+YTcRTKfJo3nXaJRK5vsKJ7QpZ37c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  m3mgolfhills: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_golfhills,
      bannerMobileImage: bannerMobileImage_golfhills,
      textOverlay: "",
      data: {
        title: "M3M Golf Hills",
        subtitle: "Sector 79, Gurugram",
        starting_price: "₹2.05 Crs*",
        rerano: "GGM/704/436/2023/48",
        payment_plan: "20:30:40:10",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Discover Luxury Living at M3M Golf Hills",
      description: [
        `M3M Golf Hills in Sector 79, Gurugram, redefines luxury living with its spacious apartments and world-class amenities.  

Offering a perfect blend of sophistication and comfort, this upscal_altitudee development is designed for those who seek an elevated lifestyle.
 From a well-equipped clubhouse and a refreshing swimming pool to beautifully landscaped gardens, every feature ensures a serene and enriching 
 living experience.  

Strategical_altitudely located, M3M Golf Hills provides excellent connectivity and easy access to essential facilities, making daily life seamless and
 convenient. More than just a name, it’s a promise of refined living at its finest!`,
      ],
      image: overviewImage_golfhills,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_golfhills,
          title: "₹2.05 Crs*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_altitude_crown,
          title: "20:30:40:10",
          subtitle: "Payment Plan",
        },
        {
          iconClass:  newlaunch_altitude_antalya_hills_antalya_hills,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_golfhills,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3.5 BHK + S",
          area: "1420 sq. ft.",
          price: "₹2.05 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "3.5 BHK + S",
          area: "2090 sq. ft.",
          price: "₹3.03 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "4.5 BHK + S",
          area: "2630  sq. ft.",
          price: "₹3.8 Crs*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3.5 BHK + S",
        area: "1420 sq. ft.",
        price: "₹2.05 Crs*",
        image: image1BHK_golfhills,
      },
      {
        type: "3.5 BHK + S",
        area: "2090 sq. ft.",
        price: "₹ 3.03 Crs*",
        image: image2BHK_golfhills,
      },
      {
        type: "4.5 BHK + S",
        area: "2630  sq. ft.",
        price: "₹3.8 Crs*",
        image: image3BHK_golfhills,
      },
    ],

    highlights: {
      images: Hightlights_golfhills,
      tagline: "Highlights",
      features: [
        "Land Area : 53.38 Acres",
        "Project Rera No. : 1331- 2023",
        "Possession Date : Mar - 2028",
        "Architecture by Arcop",
        "Payment Plan : 20:30:40:10",
      ],
    },

    location: {
      image: Location_golfhills,
      data:[
        {
          airport:{
            distance_time:"29.9 Kms",
            name:"IGI Airport"
          },
          school:{
            distance_time:"14.0 Kms",
            name:"Pragyanam School"
          },
          railwayormetro:{
            distance_time:"14.0 Kms",
            name:"Garhi Harsaru Junction"
          },
          hospital:{
            distance_time:"12.9 Kms",
            name:"Park Hospital"
          },
          mall:{
            distance_time:"13.9 Kms",
            name:"WorldMark Gurugram"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_golfhills },
        { image: g2_golfhills },
        { image: g3_golfhills },
        { image: g4_golfhills },
        { image: g5_golfhills },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in M3M Golf Hills, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is M3M Golf Hills located?",
        answer: `M3M Golf Hills is strategically located in Sector 79, Gurugram, with easy access to NH-8, SPR (Southern Peripheral Road), and key commercial hubs.`,
      },
      {
        question: "What are the available apartment configurations in M3M Golf Hills?",
        answer: `The project offers 3.5 BHK, and 4.5 BHK luxury apartments with modern layouts and spacious balconies.`,
      },
      {
        question: "What is the starting price of apartments in M3M Golf Hills?",
        answer: `The starting price for apartments in M3M Golf Hills is expected to be around ₹2.05 Crs* onwards, depending on the unit size and floor plan.`,
      },
      {
        question: "Who is the developer of M3M Golf Hills?",
        answer: `M3M Golf Hills is developed by M3M India, a reputed real estate developer known for luxury projects in Gurugram.`,
      },
      {
        question: "What is the total area of M3M Golf Hills?",
        answer: `The project spans across a vast land area, offering a golf-themed lifestyle with premium amenities and open green spaces.`,
      },
      {
        question: "What makes M3M Golf Hills a standout choice for homebuyers?",
        answer: `M3M Golf Hills in Sector 79, Gurugram, emerges as a premier choice for homebuyers seeking a harmonious blend of luxury, nature, and modern living.`,
      },
      {
        question: "Is M3M Golf Hills RERA approved?",
        answer: `Yes, M3M Golf Hills is RERA-approved, ensuring transparency and timely delivery of the project.`,
      },
      {
        question: "What is the possession date of M3M Golf Hills?",
        answer: `The expected possession date for M3M Golf Hills is around 2031.`,
      },
      {
        question: "Are there any payment plans available for M3M Golf Hills?",
        answer: `Yes, the project offers flexible payment plans, including construction-linked plans and subvention schemes for buyers.`,
      },
      {
        question: "What makes M3M Golf Hills different from other projects in Gurugram?",
        answer: `M3M Golf Hills stands out due to its golf-course views, spacious luxury apartments, high-end amenities, and strategic location in Sector 79.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "M3M - Altitude",
          developer: "M3M",
          image: altitude,
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Golf Course Extention Road",
          developer: "M3M",
          location: "Sector 65",
          bed: "2 - 4 BHK",
          size: "....",
          url: `/m3m-altitude-sector-65-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `/gviwzD0n+l5FWFX3TrhJukSQnU05OqskRJUH/LHnfUrxoS6B+yCHcS7V+kdp4wW`,
            api_userSecretKey: `k8X2fH5YCygArXlL7WJBCFLiJA2haVP3iVngXbPBWFF14gNKEl5mf4M=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Mansion",
          image: Mansion,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 113 ",
          bed: "3 - 5 BHK",
          size: "....",
          url: `/m3m-mansions-sector-113-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `kwm3G7ZL2zeBbAboxBnd4+3dqXz7Dv7PUK3/MDsjcrRkzebQjvFLYtvYaII7jar4`,
            api_userSecretKey: `n0rKmQpd7eEMCpxfID2nvzJg0LtjyOAz5mQ+DrnV/rJj30Tgm8O3g7c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      
        {
          name: "M3M - Crown",
          image: crown,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 111 ",
          bed: "3 - 4 BHK",
          developer: "M3M",
          size: "....",
          url: `/m3m-crown-sector-111-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `jJ2KcO92YUAQ4D1xLtAEDFKZr3SszswFbzyEa9Nyr5xOCanHoWyz8VgN0mTMoov0`,
            api_userSecretKey: `dEu2Lr/pQM0RhWIbECOgFfZo0DVGE1+GeJtyzDijuv3m02GEArd1+x4=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Antalya",
          image: antalya,
          developer: "M3M",
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 79 ",
          bed: "2.5 - 3.5 BHK",
          size: "....",
          url: `/m3m-antalya-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `UxnDkFbHxyiobw5sq2VRgJyU1ACW2akfrVYD6QcjetYTsWcXhd7RJjGH/DZWfKhc`,
            api_userSecretKey: `bM52Y3a/rKWN54rCYBf3Fx6qk8+YTcRTKfJo3nXaJRK5vsKJ7QpZ37c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  m3mcrown: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_crown,
      bannerMobileImage: bannerMobileImage_crown,
      textOverlay: "",
      data: {
        title: "M3M Crown",
        subtitle: "Sector 111, Gurugram",
        starting_price: "₹ 2.95 Crs*",
        rerano: "GGM/687/419/2023/31",
        payment_plan: "35:35:30",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Discover Luxury Living at M3M Crown",
      description: [
        `Situated on Dwarka Expressway, these upscal_altitudee residences redefine elegance and exclusivity.  

M3M Crown offers breathtaking architecture, extravagant interiors, and a magnificent clubhouse, creating a lifestyle of ultimate luxury. With expansive views of lush greens and serene water bodies, every detail is designed to cater to refined tastes.  

Seamlessly connected to major hotspots, this prestigious neighborhood ensures that everything you need is always within reach.`,
      ],
      image: overviewImage_crown,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_crown,
          title: "₹ 2.95 Crs*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_altitude,
          title: "35:35:30",
          subtitle: "Payment Plan",
        },
        {
          iconClass:  newlaunch_altitude_antalya_hills_altitude,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_crown,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1605 sq. ft.",
          price: "₹ 2.95 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1825 sq. ft.",
          price: "₹ 3.39 Crs*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK + SQ",
          area: "2400  sq. ft.",
          price: "₹ 4.45 Crs*",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1605 sq. ft.",
        price: "₹ 2.95 Crs*",
        image: image1BHK_crown,
      },
      {
        type: "4 BHK",
        area: "1825 sq. ft.",
        price: "₹ 3.39 Crs*",
        image: image2BHK_crown,
      },
      {
        type: "4 BHK + SQ",
        area: "2400  sq. ft.",
        price: "₹ 4.45 Crs*",
        image: image3BHK_crown,
      },
    ],

    highlights: {
      images: Hightlights_crown,
      tagline: "Highlights",
      features: [
        "5.5-acre Central Landscape With Spaces For Community And Social Activities.",
        "Central Greens Surrounded With 1.1 Km Of Pathway.",
        "Thoughtfully Designed Lake, An Unparallel Experience With Nature.",
        "Located On The Dwarka Expressway, Well Connected To The Airport.",
        "Modular Kitchen with chimney & hob.",
      ],
    },

    location: {
      image: Location_crown,
      data:[
        {
          airport:{
            distance_time:"16.4 kms",
            name:"to IGI Airport"
          },
          school:{
            distance_time:"5.6 kms",
            name:"NorthCap University"
          },
          railwayormetro:{
            distance_time:"7 Kms",
            name:"Gurugram Railway Station"
          },
          hospital:{
            distance_time:"2.7 Kms",
            name:"Park Hospital"
          },
          mall:{
            distance_time:"3.8 Kms",
            name:"Global Foyer Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_crown },
        { image: g2_crown },
        { image: g3_crown },
        { image: g4_crown },
        { image: g5_crown },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in M3M  Crown, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is M3M Crown located?",
        answer: `M3M Crown is situated in Sector 111, Gurugram, along the Dwarka Expressway, ensuring excellent connectivity to Delhi, IGI Airport, and other key areas of Gurugram.`,
      },
      {
        question: "What are the available apartment configurations in M3M Crown?",
        answer: `The project offers 3 BHK and 4 BHK luxury apartments with high-end specifications, spacious balconies, and premium interiors.`,
      },
      {
        question: "What is the starting price of apartments in M3M Crown?",
        answer: `The starting price for apartments in M3M Crown is approximately ₹2.20 Cr and varies based on size, layout, and other premium features.`,
      },
      {
        question: "What is the total area of M3M Crown?",
        answer: `The project spans over 16 acres of prime land, offering a mix of lush green landscapes, open spaces, and world-class amenities.`,
      },
      {
        question: "What are the key amenities available at M3M Crown?",
        answer: `M3M Crown offers a clubhouse, swimming pool, gymnasium, kids’ play area, jogging tracks, sports courts, landscaped gardens, and 24/7 security for a luxurious living experience.`,
      },
      {
        question: "What makes M3M Crown a standout choice for homebuyers?",
        answer: `M3M Crown, located in Sector 111, Gurugram, emerges as a premier choice for homebuyers seeking a blend of luxury, strategic location, and modern amenities.`,
      },
      {
        question: "How well is M3M Crown connected to other parts of Gurugram and Delhi?",
        answer: `The project is located along Dwarka Expressway, providing seamless connectivity to IGI Airport (10–15 minutes), Cyber City, and major business hubs in Gurugram and Delhi.`,
      },
      {
        question: "Who is the developer of M3M Crown?",
        answer: `M3M Crown is developed by M3M India, one of the leading real estate developers in India known for delivering premium residential and commercial projects.`,
      },
      {
        question: "What makes M3M Crown a good investment?",
        answer: `M3M Crown is an excellent investment due to its prime location, premium construction quality, high appreciation potential, luxury amenities, and proximity to Delhi and IGI Airport.`,
      },
      {
        question: "What are the security features in M3M Crown?",
        answer: `M3M Crown offers 24/7 security, CCTV surveillance, smart access control, gated entry, and fire safety measures for the residents' safety.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "M3M - Altitude",
          developer: "M3M",
          image: altitude,
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Golf Course Extention Road",
          developer: "M3M",
          location: "Sector 65",
          bed: "2 - 4 BHK",
          size: "....",
          url: `/m3m-altitude-sector-65-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `/gviwzD0n+l5FWFX3TrhJukSQnU05OqskRJUH/LHnfUrxoS6B+yCHcS7V+kdp4wW`,
            api_userSecretKey: `k8X2fH5YCygArXlL7WJBCFLiJA2haVP3iVngXbPBWFF14gNKEl5mf4M=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Mansion",
          image: Mansion,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 113 ",
          bed: "3 - 5 BHK",
          size: "....",
          url: `/m3m-mansions-sector-113-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `kwm3G7ZL2zeBbAboxBnd4+3dqXz7Dv7PUK3/MDsjcrRkzebQjvFLYtvYaII7jar4`,
            api_userSecretKey: `n0rKmQpd7eEMCpxfID2nvzJg0LtjyOAz5mQ+DrnV/rJj30Tgm8O3g7c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Golf Hills",
          image: GolfHills,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          location: "Sector 79 ",
          bed: "2.5 & 3.5 BHK",
          size: "....",
          url: `/m3m-golf-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `CwNJvkdl4SXQbioW3A+AfW3JSi+WTXWcnSZUtGOYntBpNSQ5iLSSDc5KjLZZfIQO`,
            api_userSecretKey: `2vnRfGW2+Xgne+ZAvWZ7S1FVr/Ve8t1N8K/Z5uhEIweIfZG8dRZHfeE=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      
        {
          name: "M3M - Antalya",
          image: antalya,
          developer: "M3M",
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 79 ",
          bed: "2.5 - 3.5 BHK",
          size: "....",
          url: `/m3m-antalya-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `UxnDkFbHxyiobw5sq2VRgJyU1ACW2akfrVYD6QcjetYTsWcXhd7RJjGH/DZWfKhc`,
            api_userSecretKey: `bM52Y3a/rKWN54rCYBf3Fx6qk8+YTcRTKfJo3nXaJRK5vsKJ7QpZ37c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  m3mantalyahills: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_antalya_hills,
      bannerMobileImage: bannerMobileImage_antalya_hills,
      textOverlay: "",
      data: {
        title: "M3M Antalya Hills",
        subtitle: "Sector 79, Gurugram",
        starting_price: "₹ 1.64 Crs*",
        rerano: "GGM/650/382/2022/125",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "M3M Antalya Hills",
      description: [
        `Situated on Dwarka Expressway, these upscal_altitudee residences redefine elegance and exclusivity.  

M3M Crown offers breathtaking architecture, extravagant interiors, and a magnificent clubhouse, creating a lifestyle of ultimate luxury. With expansive views of lush greens and serene water bodies, every detail is designed to cater to refined tastes.  

Seamlessly connected to major hotspots, this prestigious neighborhood ensures that everything you need is always within reach.`,
      ],
      image: overviewImage_antalya_hills,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_antalya_hills,
          title: "₹ 1.64 Crs*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_altitude,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass:  newlaunch_altitude_antalya_hills_antalya_hills,
          title: "Under Cunstruction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_antalya_hills,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2.5 BHK",
          area: "1146 sq. ft.",
          price: "₹ 1.64 Crs*",
          image: image1BHK_antalya_hills,
        },
        {
          type: "3.5 BHK",
          area: "1547 sq. ft.",
          price: "₹2.12 Crs*",
          image: image2BHK_antalya_hills,
        },
      ],
    },

    floor_plan: [
      {
        type: "2.5 BHK",
        area: "1146 sq. ft.",
        price: "₹ 1.64 Crs*",
        image: image1BHK_antalya_hills,
      },
      {
        type: "3.5 BHK",
        area: "1547 sq. ft.",
        price: "₹2.12 Crs*",
        image: image2BHK_antalya_hills,
      },
    ],

    highlights: {
      images: Hightlights_antalya_hills,
      tagline: "Highlights",
      features: [
        "Experience the perks of city life along with the desire of being close to nature.",
        "A township where all your what-ifs and fantasies come to reality.",
        "Sector 79 is a developing sector located in New Gurugram Micro market.",
        "There are some unique facilities such as Barbeque Pit,Lift,Gymnasium present in M3M Antalya Hills.",
        "Perimeter Security & CCTV Surveillance along with smart card access.",
      ],
    },

    location: {
      image: Location_antalya_hills,
      data:[
        {
          airport:{
            distance_time:"32.3 kms",
            name:"IGI Airport"
          },
          school:{
            distance_time:"550 Meters",
            name:"Mount Olympus School"
          },
          railwayormetro:{
            distance_time:"8.2 kms",
            name:"Proposed Manesar Metro Station"
          },
          hospital:{
            distance_time:"4.8 kms",
            name:"Miracles Apollo Hospital"
          },
          mall:{
            distance_time:"5.7 kms",
            name:"Entertainland Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_antalya_hills },
        { image: g2_antalya_hills },
        { image: g3_antalya_hills },
        { image: g4_antalya_hills },
        { image: g5_antalya_hills },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in M3M  Antalya Hills, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is M3M Antalya Hills situated?",
        answer: `The project is situated in Sector 79, Gurugram, Haryana, India.`,
      },
      {
        question: "What types of residences are available at M3M Antalya Hills?",
        answer: `The project offers 2.5 BHK and 3.5 BHK luxury low-rise floors.`,
      },
      {
        question: "What are the sizes of the apartments?",
        answer: `The apartments range from approximately 1146 sq. ft. to 1547 sq. ft.`,
      },
      {
        question: "What is the starting price for these residences?",
        answer: `Prices start from ₹1.6 crore for a 2.5 BHK unit.`,
      },
      {
        question: "When is the expected possession date?",
        answer: `The expected possession date is December 2026.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, M3M Antalya Hills is RERA registered under numbers GGM/650/382/2022/125.`,
      },
      {
        question: "What amenities are offered in the project?",
        answer: `Amenities include a clubhouse, swimming pool, fitness center, landscaped gardens, children's play areas, and more.`,
      },
      {
        question: "What makes M3M Antalya Hills a standout choice for homebuyers?",
        answer: `M3M Antalya Hills, located in Sector 79, Gurugram, is an exceptional residential project that offers a harmonious blend of luxury, modern amenities, and natural serenity.`,
      },
      {
        question: "What are the key features of M3M Antalya Hills?",
        answer: `Key features include Italian marble flooring, modular kitchens with hob and chimney, air-conditioned lobbies, and a 5-star clubhouse.`,
      },
      {
        question: "Is the project a good investment?",
        answer: `Yes, due to its strategic location, luxurious amenities, and the developer's reputation, it is considered a promising investment opportunity.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "M3M - Altitude",
          developer: "M3M",
          image: altitude,
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Golf Course Extention Road",
          developer: "M3M",
          location: "Sector 65",
          bed: "2 - 4 BHK",
          size: "....",
          url: `/m3m-altitude-sector-65-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `/gviwzD0n+l5FWFX3TrhJukSQnU05OqskRJUH/LHnfUrxoS6B+yCHcS7V+kdp4wW`,
            api_userSecretKey: `k8X2fH5YCygArXlL7WJBCFLiJA2haVP3iVngXbPBWFF14gNKEl5mf4M=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Mansion",
          image: Mansion,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 113 ",
          bed: "3 - 5 BHK",
          size: "....",
          url: `/m3m-mansions-sector-113-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `kwm3G7ZL2zeBbAboxBnd4+3dqXz7Dv7PUK3/MDsjcrRkzebQjvFLYtvYaII7jar4`,
            api_userSecretKey: `n0rKmQpd7eEMCpxfID2nvzJg0LtjyOAz5mQ+DrnV/rJj30Tgm8O3g7c=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Golf Hills",
          image: GolfHills,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Golf Course Road",
          location: "Sector 79 ",
          bed: "2.5 & 3.5 BHK",
          size: "....",
          url: `/m3m-golf-hills-sector-79-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `CwNJvkdl4SXQbioW3A+AfW3JSi+WTXWcnSZUtGOYntBpNSQ5iLSSDc5KjLZZfIQO`,
            api_userSecretKey: `2vnRfGW2+Xgne+ZAvWZ7S1FVr/Ve8t1N8K/Z5uhEIweIfZG8dRZHfeE=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "M3M - Crown",
          image: crown,
          price: "On Request",
          developer: "M3M",
          state: "Gurugram",
          projectlocation: "Dwarka Expressway",
          location: "Sector 111 ",
          bed: "3 - 4 BHK",
          developer: "M3M",
          size: "....",
          url: `/m3m-crown-sector-111-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `jJ2KcO92YUAQ4D1xLtAEDFKZr3SszswFbzyEa9Nyr5xOCanHoWyz8VgN0mTMoov0`,
            api_userSecretKey: `dEu2Lr/pQM0RhWIbECOgFfZo0DVGE1+GeJtyzDijuv3m02GEArd1+x4=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};